import { Routes } from "@angular/router";

export const routes: Routes = [
  { path: "", pathMatch: "full", redirectTo: "/erfassungswelle" },
  {
    path: "questionnaire",
    loadChildren: () => import("./features/questionnaire/routes").then((m) => m.QUESTIONNAIRE_ROUTES)
  },
  {
    path: "answered-questionnaire",
    loadChildren: () => import("./features/answered-questionnaire/routes").then((m) => m.ANSWERED_QUESTIONNAIRE_ROUTES)
  },
  {
    path: "erfassungswelle",
    loadChildren: () => import("./features/erfassungswelle/routes").then((m) => m.ERFASSUNGSWELLE_ROUTES)
  },
  {
    path: "answer-list",
    loadChildren: () => import("./features/answer-list/routes").then((m) => m.ANSWER_LIST_ROUTES)
  },
  {
    path: "notification",
    loadChildren: () => import("./features/notification/routes").then((m) => m.NOTIFICATION_ROUTES)
  },
  {
    path: "counting",
    loadChildren: () => import("./features/counting/routes").then((m) => m.COUNTING_ROUTES)
  },
  {
    path: "picture",
    loadChildren: () => import("./features/picture/routes").then((m) => m.PICTURE_ROUTES)
  },
  {
    path: "user-management",
    loadChildren: () => import("./features/user-management/routes").then((m) => m.USER_MANAGEMENT_ROUTES)
  },
  {
    path: "schedule",
    loadChildren: () => import("./features/schedule/routes").then((m) => m.SCHEDULE_ROUTES)
  }
];
